export enum PregnantRegisterSteps {
  consentAgreement = 0,
  pregnantDetails = 1,
  pregnantContactInformation = 2,
  pregnantAddress = 3,
  pregnantMaternalRecord = 4,
}
